import React from 'react';
import { Accordion, Alert, Badge, Button, Card, Spinner, Table } from 'react-bootstrap';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import { timeToInt } from 'time-number';
import { Auth, API } from "aws-amplify";
import { Locations } from "../../components/contstants/Locations";
import { downloadStudentImportXlsx } from "../../utils/studentImportExport";

import './Appointment.css';

export default class AttendeeList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDate: "",
            APIDateStudentResults: [],
            unslotedMembers: [],
            selectedDay: [],
            selectedDays: [],
            activeKey: '0',
            selectedDaysRange: "",
            dataDirty: false,
            locations: Locations,
            studentImportWarnings: []
        };
        this.onDateChange = this.onDateChange.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.sortSlots = this.sortSlots.bind(this);
        this.formatPhoneNumbers = this.formatPhoneNumbers.bind(this);
    }

    handleGetSlotsbyDay = async (day) => {
        let dateNeeded = moment(day).format("YYYY-MM-DD");
        this.setState({ loadingDay: true });
        const that = this;

        let session = await Auth.currentSession();
        let options = {
            body: { "date": dateNeeded },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': session.idToken.jwtToken
            }
        };
        try {
            let data = await API.post("APIGateway", "/v2getStudentsByFilter", options);
            data = this.sortSlots(data, "slot");
            data = this.formatPhoneNumbers(data);
            that.setState({ loadingDay: false, fetchedStudents: true });
            return data;
        } catch (e) {
            console.log(e);
            that.setState({ loadingDay: false });
            return [];
        }
    };

    async handleDayClick(date, { selected }) {
        let selectedDaysRange = "";
        let dayOfWeek = date.getDay();
        let selectedDays = [];

        if (dayOfWeek === 0) {
            selectedDays.push(moment(date).subtract(1, 'd').toDate());
            selectedDays.push(moment(date).toDate());
        } else if (dayOfWeek === 6) {
            selectedDays.push(moment(date).toDate());
            selectedDays.push(moment(date).add(1, 'd').toDate());
        } else {
            selectedDays = [date];
        }
        this.setState({ selectedDays });

        let selectedDay = selectedDays[0];
        selectedDaysRange += moment(selectedDay).format('LL') + " - ";

        let APIDateStudentResults = await this.handleGetSlotsbyDay(selectedDay);

        if (APIDateStudentResults.length > 0) {
            if (APIDateStudentResults[0].hasOwnProperty('slot')) {
                APIDateStudentResults = this.sortSlots(APIDateStudentResults, 'slot');
            } else {
                APIDateStudentResults = this.sortSlots(APIDateStudentResults, 'unslotTime');
            }
            var selectedWeekenedDates = new Set(APIDateStudentResults.filter(x => x.weekendDate).map(x => x.weekendDate));
            selectedWeekenedDates = [...selectedWeekenedDates];
            if (selectedWeekenedDates.length > 0) {
                var selectedWeekday = selectedWeekenedDates[0];
                var weekArray = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
                var weekendArray = ["Saturday", "Sunday"];
                if (dayOfWeek === 6) {
                    this.setState({ dayOfExam: selectedDays[weekendArray.indexOf(selectedWeekday)], selectedWeekday });
                } else {
                    this.setState({ dayOfExam: selectedDays[weekArray.indexOf(selectedWeekday)], selectedWeekday });
                }
                this.setState({ unslotedMembers: APIDateStudentResults.filter(x => !x.slot) });
            }
        }

        selectedDaysRange += moment(selectedDays[selectedDays.length - 1]).format('LL');
        this.setState({ selectedDay, APIDateStudentResults, selectedDaysRange, unsavedManuallyAddedStudents: [], dataDirty: true });
    }

    handleErrors = (response) => {
        if (!response.ok) {
            console.log(response.statusText);
        }
        return response;
    };

    sortSlots(array, key) {
        if (array.length === 0) return [];
        return array.sort(function (a, b) {
            var x = a.hasOwnProperty(key) ? timeToInt(a[key]) : 0;
            var y = b.hasOwnProperty(key) ? timeToInt(b[key]) : 0;
            return x < y ? -1 : x > y ? 1 : 0;
        });
    }

    formatPhoneNumbers(arrayOfStudents) {
        return arrayOfStudents.map(student => {
            var cleaned = ('' + student.phone).replace(/\D/g, '');
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                student.phone = '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }
            return student;
        });
    }

    // Fills in totalProgram/paymentType/initalPayment so the xlsx export
    // reports the same numbers as the Add/Move/Delete Students page.
    enrichStudentsForExport = (students) =>
        students.map((student) => {
            student.totalProgram = student.fullPricing
                .map((x) => x.price)
                .reduce((a, b) => a + b, 0);
            if (!student.paymentType) {
                student.paymentType = "Credit Card";
            }
            student.initalPayment = student.totalProgram;
            return student;
        });

    handleStudentImportXlsxDownload = () => {
        const data = this.enrichStudentsForExport(this.state.APIDateStudentResults);
        const filename = moment(this.state.selectedDay).format("YYYY_MM_DD") + "_StudentImport.xlsx";
        const { warnings } = downloadStudentImportXlsx(data, filename);
        this.setState({ studentImportWarnings: warnings });
    };

    onDateChange(e) {
        this.setState({ selectedDate: e.currentTarget.value });
    }

    handleSelect(activeKey) {
        this.setState({ activeKey });
    }

    render() {
        const { activeKey, selectedDays, selectedDaysRange, APIDateStudentResults, locations } = this.state;
        const locationsWithStudents = locations.filter(loc => APIDateStudentResults.some(x => x.location === loc));

        return (
            <div className="holder">
                <div style={{ marginBottom: "1.25rem" }}>
                    <h3 style={{ marginBottom: "0.25rem" }}>Print Road Test Schedule</h3>
                    <small className="text-muted">Select a date to load the roster, then print.</small>
                </div>

                <Accordion defaultActiveKey="0" activeKey={activeKey}>
                    {/* Step 1 — pick a date */}
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.setState({ activeKey: "0" })}
                            style={{ cursor: "pointer" }}>
                            {selectedDaysRange.length > 0 ? selectedDaysRange : "Select Date"}
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <DayPicker
                                    numberOfMonths={2}
                                    selectedDays={selectedDays}
                                    showOutsideDays
                                    onDayClick={this.handleDayClick}
                                />

                                {this.state.loadingDay && (
                                    <div style={{ marginTop: "0.75rem", color: "#6c757d" }}>
                                        <Spinner animation="border" size="sm" /> Loading students…
                                    </div>
                                )}

                                {this.state.dataDirty && !this.state.loadingDay && (
                                    <div style={{ marginTop: "0.75rem" }}>
                                        {APIDateStudentResults.length > 0 ? (
                                            <Alert variant="info" style={{ padding: "0.4rem 0.75rem", display: "inline-block" }}>
                                                {APIDateStudentResults.length} student{APIDateStudentResults.length === 1 ? "" : "s"} found
                                            </Alert>
                                        ) : (
                                            <Alert variant="secondary" style={{ padding: "0.4rem 0.75rem", display: "inline-block" }}>
                                                No students found for this date.
                                            </Alert>
                                        )}
                                    </div>
                                )}

                                <div style={{ marginTop: "1rem" }}>
                                    <Button
                                        variant="primary"
                                        disabled={this.state.loadingDay || this.state.selectedDay.length === 0}
                                        onClick={() => this.setState({ activeKey: "1" })}
                                    >
                                        View Roster
                                    </Button>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>

                    {/* Step 2 — roster */}
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => this.setState({ activeKey: "1" })}
                            style={{ cursor: "pointer" }}>
                            <span>Roster</span>
                            {locationsWithStudents.length > 0 && (
                                <Badge variant="primary" style={{ marginLeft: "0.5rem" }}>
                                    {APIDateStudentResults.length}
                                </Badge>
                            )}
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                {locationsWithStudents.length === 0 ? (
                                    <p className="text-muted">
                                        {this.state.dataDirty
                                            ? "No students found for the selected date."
                                            : "Select a date first to load the roster."}
                                    </p>
                                ) : (
                                    <>
                                        <div style={{ marginBottom: "1rem", display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                                            <Button variant="outline-secondary" size="sm" onClick={() => window.print()}>
                                                Print
                                            </Button>
                                            <Button variant="outline-secondary" size="sm" onClick={this.handleStudentImportXlsxDownload}>
                                                Download Student Import File (.xlsx)
                                            </Button>
                                        </div>
                                        {this.state.studentImportWarnings.length > 0 && (
                                            <Alert
                                                variant="warning"
                                                dismissible
                                                onClose={() => this.setState({ studentImportWarnings: [] })}
                                                style={{ marginBottom: "1rem" }}
                                            >
                                                <strong>The downloaded Student Import file has some rows that may need review:</strong>
                                                <ul style={{ marginBottom: 0 }}>
                                                    {this.state.studentImportWarnings.map((warning, index) => (
                                                        <li key={index}>{warning}</li>
                                                    ))}
                                                </ul>
                                            </Alert>
                                        )}

                                        {locationsWithStudents.map(location => {
                                            const students = APIDateStudentResults.filter(x => x.location === location);
                                            return (
                                                <div key={location} style={{ marginBottom: "1.5rem" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.5rem" }}>
                                                        <h5 style={{ margin: 0 }}>{location}</h5>
                                                        <Badge variant="secondary">{students.length}</Badge>
                                                    </div>
                                                    <Table striped bordered hover responsive size="sm">
                                                        <thead className="thead-dark">
                                                            <tr className="d-flex">
                                                                <th className="col-2">Slot</th>
                                                                <th className="col-4">Name</th>
                                                                <th className="col-2">Phone</th>
                                                                <th className="col-4">Notes</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {students.map(x => (
                                                                <tr key={x.timestamp} className="d-flex">
                                                                    <td className="col-2">{x.slot || x.unslotTime || "—"}</td>
                                                                    <td className="col-4">{x.fName} {x.lName}</td>
                                                                    <td className="col-2">{x.phone}</td>
                                                                    <td className="col-4">{x.note || ""}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            );
                                        })}
                                    </>
                                )}
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        );
    }
}
